import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, RadioFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectIncomingPaymentOptions, selectIncomingTaxesOptions } from "@redux";

export const ClientPlanTurn = ({ control }) => {
  const incomingPaymentsOptions = useSelector(selectIncomingPaymentOptions);
  const incomingTaxesOptions = useSelector(selectIncomingTaxesOptions);

  return (
    <StepperFormRow>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name="clientPlanTurn.0.data.clientPlanTurnover"
        defaultValue="PLTUR1"
        className="d-none"
      />

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientPlanTurn.0.data.incPaym"
          title={trb(i18.Labels.IncPaym)}
          options={incomingPaymentsOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientPlanTurn.0.data.incRem"
          title={trb(i18.Labels.IncRem)}
          options={incomingTaxesOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
